import React, { memo } from 'react';
export function Story() {
  return <section className="py-8 px-4 bg-cream" data-id="element-276">
      <div className="max-w-3xl mx-auto" data-id="element-277">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8" data-id="element-278">
          La historia que tal vez también es la tuya…
        </h2>

        <div className="prose prose-lg prose-p:text-warm-brown-dark prose-headings:text-warm-brown-dark mx-auto space-y-4 text-base leading-relaxed" data-id="element-279">
          <p data-id="element-280">Había una mujer que lo tenía "todo resuelto" en papel.</p>
          <p data-id="element-281">
            Trabajo, casa, familia. Pero a las 2 de la mañana, cuando la casa
            quedaba en silencio, sentía un nudo en el vientre que no podía
            explicar. Una pesadez que no era tristeza exactamente. Era algo más
            antiguo. Más profundo.
          </p>
          <p data-id="element-282">
            Fue a terapia. Le dijeron que era ansiedad. Le dieron técnicas de
            respiración.
          </p>
          <p data-id="element-283">
            Hizo yoga. Mejoró un poco. Pero volvía siempre al mismo lugar: esa
            sensación de que "algo no encajaba" en su vida. Que había una
            versión de ella misma, más libre, más liviana, más poderosa… que no
            terminaba de nacer.
          </p>
          <p data-id="element-284">
            Un día, mientras hablaba con su madre por teléfono —una conversación
            que terminó, como siempre, con culpa y agotamiento— se preguntó algo
            que lo cambió todo:
          </p>

          <div className="my-6 p-6 bg-soft-rose rounded-xl text-center shadow-sm" data-id="element-285">
            <h3 className="text-xl md:text-2xl font-bold italic text-deep-rose m-0" data-id="element-286">
              "¿Cuánto de lo que siento es realmente mío?"
            </h3>
          </div>

          <p data-id="element-287">
            Esa pregunta la llevó a descubrir algo que la ciencia hoy confirma y
            que las abuelas sabían hace siglos:
          </p>

          <h4 className="text-xl font-bold text-center my-6" data-id="element-288">
            El cuerpo de la mujer guarda la historia de todas las mujeres que la
            precedieron.
          </h4>

          <ul className="space-y-3 list-none pl-0 my-6" data-id="element-289">
            <li className="flex items-center gap-3" data-id="element-290">
              <span className="text-deep-rose" data-id="element-291">🌹</span>
              <span data-id="element-292">
                Tu útero no es solo un órgano.{' '}
                <strong data-id="element-293">Es una vasija de memorias.</strong>
              </span>
            </li>
            <li className="flex items-center gap-3" data-id="element-294">
              <span className="text-deep-rose" data-id="element-295">💗</span>
              <span data-id="element-296">
                Tu pecho no es solo glándulas.{' '}
                <strong data-id="element-297">Es el centro donde procesás el dolor ajeno.</strong>
              </span>
            </li>
            <li className="flex items-center gap-3" data-id="element-298">
              <span className="text-deep-rose" data-id="element-299">🎵</span>
              <span data-id="element-300">
                Tu garganta no es solo voz.{' '}
                <strong data-id="element-301">Es el espejo exacto de lo que no pudiste decir.</strong>
              </span>
            </li>
          </ul>

          <p data-id="element-302">
            Y cuando esas memorias no se limpian, se manifiestan. En dolores
            físicos. En patrones repetidos. En esa sensación de que "algo te
            frena" aunque no sepas qué es.
          </p>

          <div className="text-center mt-8 pt-6 border-t border-soft-rose" data-id="element-303">
            <p className="text-lg font-semibold" data-id="element-304">
              Esa mujer encontró el camino. Y este método nació de ese
              despertar.
            </p>
            <p className="text-lg font-bold text-deep-rose mt-2" data-id="element-305">
              Hoy, ese método está en tus manos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}